(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/widgets-campaign/assets/javascripts/frames/mothersDay2024/mothers-day.js') >= 0) return;  svs.modules.push('/modules/widgets-campaign/assets/javascripts/frames/mothersDay2024/mothers-day.js');
"use strict";

const _React = React,
  Fragment = _React.Fragment;
const mothersDay2024Path = "".concat(svs.core.config.data.svsconfig.cdn, "/images/widgets-campaign/mothersDay2024");
const TopFrame = () => React.createElement("div", {
  className: "mothers-day-top-frame row pointer-none"
}, React.createElement("div", {
  className: "mothers-day-top-frame-container relative col-md-12"
}, React.createElement("img", {
  alt: "Morsdag-ram-\xF6verdel",
  className: "top-frame-mothers-day",
  src: "".concat(mothersDay2024Path, "/morsdag-ram-topp.png")
})));
const BottomFrame = () => React.createElement("div", {
  className: "mothers-day-bottom-frame row pointer-none"
}, React.createElement("div", {
  className: "mothers-day-bottom-layers relative col-md-12"
}, React.createElement("img", {
  alt: "Morsdag-ram-nederdel",
  className: "bottom-frame-mothers-day",
  src: "".concat(mothersDay2024Path, "/morsdag-ram-botten.png")
})));
const MothersDay = _ref => {
  let children = _ref.children,
    _ref$showTop = _ref.showTop,
    showTop = _ref$showTop === void 0 ? true : _ref$showTop,
    _ref$showBottom = _ref.showBottom,
    showBottom = _ref$showBottom === void 0 ? true : _ref$showBottom;
  return React.createElement(Fragment, null, showTop && React.createElement(TopFrame, null), children, showBottom && React.createElement(BottomFrame, null));
};
setGlobal('svs.widgetsCampaign.frames.mothersDay2024.MothersDay', MothersDay);

 })(window);